import { ProjectOutlined } from '@ant-design/icons'
import { CollectionProps } from 'app/components/Core/convention'
import KList from 'app/components/Modules/List/KList'
import KListItem from 'app/components/Modules/List/KListItem'
import { RecordType } from 'app/constants/GlobalTypes'
import * as React from 'react'

interface Props extends React.ComponentProps<typeof KList> {
  onItemClick?: (item: IProject) => void
}

const ProjectList: React.FC<CollectionProps<IProject, Props>> = ({
  collection,
  props: { onItemClick, ...others } = {}
}) => {
  return (
    <KList
      footer={null}
      showTotal={false}
      dataSource={collection}
      recordType={RecordType.project}
      renderItem={(item: IProject) => (
        <KListItem
          onClick={() => onItemClick?.(item)}
          avatar={<ProjectOutlined className="font-size-22" />}
          description={item?.name === item?.display_address ? undefined : item?.display_address}
          title={item.name}
        />
      )}
      {...others}
    />
  )
}

export default ProjectList
